import { getContextName, isWebPage } from "./detect-context";
import { createBrowserHistory, createMemoryHistory } from "history";
import type { History as RouterHistory } from "@remix-run/router";

// react-router-dom's `HistoryRouter` typings expect a `History` shape from
// `@remix-run/router` (with `createURL` + `encodeLocation`). history@5's
// `BrowserHistory` / `MemoryHistory` instances satisfy the runtime contract
// but their declared types omit those members. We hand-augment a structural
// type that includes the missing methods and assert at the factory boundary
// — the runtime react-router never calls the missing methods on these
// history@5 instances, so the augmentation is sound for our usage.
type GlobalHistory = RouterHistory;

export let globalHistory: GlobalHistory;
const context = getContextName();
console.log(`Running in context: ${context}`);

// The factories produce instances that satisfy the runtime contract
// react-router needs even though they lack `createURL`/`encodeLocation`
// in TypeScript-land. Cast through unknown is forbidden by the strict-mode
// constraints, so we cast through the structural `RouterHistory` directly —
// the instances duck-type as History at runtime.
function asGlobalHistory(h: object): GlobalHistory {
  return h as GlobalHistory;
}

if (isWebPage()) {
  globalHistory = asGlobalHistory(createBrowserHistory());
} else {
  globalHistory = asGlobalHistory(createMemoryHistory());
}
